import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";
import { Shield } from "lucide-react";

export const FreeSmallBusinessPlan = () => {
  const navigate = useNavigate();

  return (
    <section className="py-12 px-4">
      <div className="container mx-auto max-w-6xl">
        <Card className="overflow-hidden border-2 border-primary/20">
          <div className="grid md:grid-cols-2 gap-0">
            {/* Left side - Image/Visual */}
            <div className="bg-gradient-to-br from-primary/10 to-purple-500/10 p-12 flex items-center justify-center">
              <div className="text-center space-y-4">
                <div className="relative inline-block">
                  <div className="absolute inset-0 bg-primary/20 rounded-full blur-3xl animate-pulse" />
                  <div className="relative bg-background/80 backdrop-blur-sm rounded-full p-8 border border-primary/20">
                    <Shield className="w-24 h-24 text-primary" />
                  </div>
                </div>
                <p className="text-lg font-medium">Perfect for Small Teams</p>
              </div>
            </div>

            {/* Right side - Content */}
            <div className="p-8 md:p-12 flex flex-col justify-center">
              <div className="space-y-6">
                <div>
                  <p className="text-sm text-muted-foreground mb-2">Managing up to 10 guards?</p>
                  <h2 className="text-3xl md:text-4xl font-bold mb-3">
                    Meet the Small Business Plan
                  </h2>
                  <p className="text-lg text-muted-foreground">
                    The security management platform that sets your business up for success –{" "}
                    <span className="font-semibold text-foreground">
                      all modules and all features, entirely free for up to 10 users
                    </span>
                  </p>
                </div>

                <div className="flex items-baseline gap-2">
                  <span className="text-6xl font-bold">€0</span>
                  <span className="text-xl text-muted-foreground">Free for life</span>
                </div>

                <Button 
                  size="lg"
                  className="w-full md:w-auto bg-gradient-to-r from-primary to-purple-600 text-white hover:opacity-90 shadow-enhanced text-lg px-8"
                  onClick={() => navigate("/auth")}
                >
                  Join for Free
                </Button>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </section>
  );
};
